export enum VoiceName {
  Puck = 'Puck',
  Charon = 'Charon',
  Kore = 'Kore',
  Fenrir = 'Fenrir',
  Zephyr = 'Zephyr',
}

export interface BotConfig {
  name: string;
  voice: VoiceName;
  systemInstruction: string;
  themeColor: string;
  avatarUrl: string;
  webhookUrl?: string;
  previewUrl?: string;
  googleSheets?: string[];
}

export interface MessageLog {
  role: 'user' | 'model';
  text: string;
  timestamp: Date;
}